import { inject, Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IFiltersSaver, SavedFilterState } from '../../../libs/shared/services/filters-saver';
import {
  HrSavedFiltersDataAccessService,
  HrSavedFilterType,
} from './hr-saved-filters-data-access.service';

@Injectable({ providedIn: 'root' })
export class HrFiltersSaverService implements IFiltersSaver {
  protected readonly dataAccess = inject(HrSavedFiltersDataAccessService);

  save(type: HrSavedFilterType, form: AbstractControl): void {
    this.dataAccess.setSavedFilter(type, JSON.stringify(form.getRawValue())).subscribe();
  }

  restore(type: HrSavedFilterType, form: AbstractControl): Observable<boolean> {
    return this.dataAccess.getSavedFilter(type).pipe(
      map((savedFilter) => {
        if (savedFilter?.Filter) {
          form.patchValue(JSON.parse(savedFilter.Filter));
          return true;
        }
        return false;
      })
    );
  }

  clearSaved(type: HrSavedFilterType): Observable<void> {
    return this.dataAccess.setSavedFilter(type, null);
  }

  getSavedState(type: HrSavedFilterType, _form?: AbstractControl): Observable<SavedFilterState> {
    return this.dataAccess
      .getSavedFilter(type)
      .pipe(
        map((savedFilter) =>
          savedFilter?.Filter
            ? { hasSaved: true, value: JSON.parse(savedFilter.Filter) }
            : { hasSaved: false, value: null }
        )
      );
  }
}
